<template>
    <LoadingScreen v-if="isLoadingScreen" />
    <div v-else class="screen-result">
        <TitleCommon title="result" :isShowButtonBack="true" />
        <div class="screen-result__container">
            <div class="screen-result__tab" v-if="$store.state.betSlip.isNav">
                <div
                    v-for="(item, index) in $store.state.tabLotto.list"
                    :class="['screen-result__tab-item', { active: tab.active === item.key }, { full: $store.state.tabLotto?.list?.length === 1}]"
                    :key="index"
                    @click="onChangeTab(item.key)"
                >
                    {{ item.label }}
                </div>
            </div>
            <ResultHeaderComponent :dateSelect="date" @on-clear-filter-date="onChangeDatePicker(null)" />
            <LoadingScreen v-if="isLoadingFilter" />
            <ResultComponent v-else-if="dataSource.length > 0" :dataSource="dataSource" :dateSelect="date"/>
            <EmptyDate v-else text="no data" />
        </div>
    </div>
</template>
<script>
import LoadingScreen from '@/components/common/loading/loading.vue';
import ResultService from '@/services/result/result.service';
import EmptyDate from '@/components/common/emptyScreen/empty.vue';
import TitleCommon from '@/components/common/title/index.vue';

import ResultHeaderComponent from '@/components/result/header.vue';
import ResultComponent from '@/components/result/index.vue';
import EventBus from '@/utils/EventBus';
import { formatDate, isStrEmpty } from '@/utils/utils';

export default {
    components: { LoadingScreen, TitleCommon, ResultComponent, ResultHeaderComponent, EmptyDate },
    data() {
        return {
            dataSource: [],
            isLoadingScreen: true,
            isLoadingFilter: false,
            date: '',
            tab: {
                active: 'okapiLottery',
            },
        };
    },
    created() {
        const tabActive = this.$store.state.betSlip.okapiLottery ? 'okapiLottery' : 'dailyLotto';
        this.tab.active = tabActive;

        const dateFormat = formatDate(new Date());
        this.date = `${dateFormat.year}-${dateFormat.month}-${dateFormat.day}`;

        this.fetchData();
        EventBus.on('on-select-datepicker-result', (param) => {
            this.onChangeDatePicker(param);
        });
    },
    unmounted() {
        EventBus.off('on-select-datepicker-result');
    },
    methods: {
        async fetchData(isFilter = false) {
            try {
                this.isLoadingScreen = !isFilter;
                this.isLoadingFilter = isFilter;
                let resp = null;

                if (this.tab.active === 'okapiLottery') {
                    resp = await ResultService.getList(this.date);
                } else {
                    resp = await ResultService.getListDaily(this.date);
                }

                if (resp.code === 200) {
                    this.dataSource = resp.data;
                } else {
                    const param = {
                        text: resp.message,
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                }
                this.isLoadingScreen = false;
                this.isLoadingFilter = false;
            } catch (error) {
                this.isLoadingScreen = false;
                console.log(error);
            }
        },

        onChangeTab(key) {
            this.tab.active = key;
            this.onChangeDatePicker();
        },

        onChangeDatePicker(param) {
            const date = !isStrEmpty(param?.date) ? param.date : '';
            console.log(date)
            this.date = date;
            this.fetchData(true);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/result/index.scss';
</style>
